import React, { FC } from 'react';
//import './styles.css';

const Breadcrumbs: FC <{newsListing : any}> = ({newsListing}) => {
    
    return (
        <div className="breadcrumbs">	
            <div className="container" >
            <ol>
                <li><a href="/" className="active blue-color">Home</a> </li>
                <li><a href="">News and Events</a></li>
            </ol>
            </div>
	    </div>
    );
};

export default Breadcrumbs;